import React from "react";

const ArrowDouble = () => (
  <svg width="8" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.82 12.843a.3.3 0 00.509 0L7.07 8.46A.3.3 0 006.816 8H1.332a.3.3 0 00-.254.46l2.742 4.383zM3.82.407a.3.3 0 01.509 0L7.07 4.79a.3.3 0 01-.255.459H1.332a.3.3 0 01-.254-.46L3.82.408z" fill="#B8BEC8" />
  </svg>
);

export default ArrowDouble;
